import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Job } from '../../firestore_model';
import { useInjection } from '../../../di_container/InjectionProvider';
import { useClinicUser } from './ClinicUserHooks';
import { Clinic, ClinicCounter } from '../../firestore_model/job';
export const useClinic = () => {
    const { container } = useInjection();
    const { jobClinic } = useClinicUser();
    const [loading, setLoading] = useState(false);
    const [loadingCoupon, setLoadingCoupon] = useState(false);
    const uploadProfileImage = useCallback(async (file) => {
        if (loading || jobClinic === undefined)
            return;
        setLoading(true);
        try {
            const repository = container.resolve('CloudStorageRepository');
            const filename = Job.Clinic.imageName;
            const result = await repository.upload(file, filename, `${jobClinic.documentReference.path}/${Job.Clinic.imageFolderName}`);
            jobClinic.setImageFromCloudStorage(result);
            await jobClinic.update();
        }
        catch (e) {
            console.error('error', e);
            setLoading(false);
            throw e;
        }
        setLoading(false);
    }, [jobClinic]);
    const registerCreditAccount = useCallback(async (paymentMethod, creditCardToken) => {
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.registerAccount(paymentMethod, creditCardToken);
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const loadCreditCard = useCallback(async () => {
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            const result = await imoryApiRepository.loadCreditCard();
            setLoading(false);
            return result;
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const registerPlan = useCallback(async (planType, paymentMethod) => {
        const uuid = uuidv4();
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.registerPlan(planType, paymentMethod, uuid);
            setLoading(false);
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const cancelPlan = useCallback(async () => {
        const uuid = uuidv4();
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            const result = await imoryApiRepository.cancelPlan(uuid);
            setLoading(false);
            return result;
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const registerCoupon = useCallback(async (couponId) => {
        setLoadingCoupon(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            await imoryApiRepository.registerCoupon(couponId);
            setLoadingCoupon(false);
        }
        catch (e) {
            setLoadingCoupon(false);
            throw e;
        }
    }, []);
    const loadClinicCounter = useCallback(async (clinicId) => {
        setLoading(true);
        try {
            const result = await ClinicCounter.get(new Clinic(clinicId).clinicCounter.collectionReference.doc(ClinicCounter.documentId));
            setLoading(false);
            return result;
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    const loadContractRenewal = useCallback(async () => {
        setLoading(true);
        try {
            const imoryApiRepository = container.resolve('ImoryApiRepository');
            const result = await imoryApiRepository.loadContractRenewal();
            setLoading(false);
            return result;
        }
        catch (e) {
            setLoading(false);
            throw e;
        }
    }, []);
    return {
        loading,
        loadingCoupon,
        uploadProfileImage,
        registerCreditAccount,
        loadCreditCard,
        registerPlan,
        cancelPlan,
        registerCoupon,
        loadClinicCounter,
        loadContractRenewal,
    };
};
